import { render, staticRenderFns } from "./selectText.vue?vue&type=template&id=2c0baea8&scoped=true"
import script from "./selectText.vue?vue&type=script&lang=js"
export * from "./selectText.vue?vue&type=script&lang=js"
import style0 from "./selectText.vue?vue&type=style&index=0&id=2c0baea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0baea8",
  null
  
)

export default component.exports